




import Plotly from "plotly.js-dist";
//import 'reflect-metadata';
import { Vue, Component, Prop, Watch } from "vue-property-decorator"; // Component, Prop, Vue, Watch, Provide, Inject, Computed

@Component({})
export default class PlotlyPlot extends Vue {
  @Prop() private height!: number;
  @Prop() private width!: number;

  @Prop() private data!: Plotly.Data[];
  @Prop() private layout!: Partial<Plotly.Layout>;
  @Prop() private config!: Partial<Plotly.Config>;

  private dataRevisionVersion = 0;

  public get reactiveLayout(): Partial<Plotly.Layout> {
    return {
      ...this.layout,
      datarevision: this.dataRevisionVersion
    } as Partial<Plotly.Layout>;
  }

  @Watch("data", { deep: true })
  onDataChanged() {
    this.dataRevisionVersion++;
  }

  @Watch("layout", { deep: true })
  onLayoutChanged() {
    console.log("changedLayout");
    this.dataRevisionVersion++;
  }

  @Watch("config", { deep: true })
  onConfigChanged() {
    this.dataRevisionVersion++;
  }

  @Watch("dataRevisionVersion")
  onRevisionChanged() {
    this.$nextTick(this.react);
  }

  $el!: HTMLElement; // enforce type at class instead of in each method

  beforeDestroy() {
    Plotly.purge(this.$el);
  }

  // zoomChanged(eventData) {
  //   console.log("chaanged");
  //   this.$emit('zoom',eventData);
  // }

  mounted() {
    Plotly.newPlot(this.$el, this.data, this.reactiveLayout, this.config);
    //this.$el.on('plotly_relayout', this.zoomChanged);
  }

  react() {
    Plotly.react(this.$el, this.data, this.reactiveLayout, this.config);
  }
}
